module.exports = __webpack_public_path__ + "img/cobbl4.aec0b29d.jpeg";